import FactureAvoirPartielRefactController from './facture.avoir.partiel.refact.controller';

export default {
    bindings: {
        modalInstance: '=',
        avoirResult: '=',
        date: '='
    },
    template: require('./facture.avoir.partiel.refact.html'),
    controller: FactureAvoirPartielRefactController
};